var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTabbarTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_tabbar_trade") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-107, -17)",
    stroke: "#0E1C39",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.002047,21.0005444 C125.002235,23.1902967 126.948575,26.7139782 126.948575,30.6878129 C126.948575,31.323417 126.898781,31.9475048 126.802846,32.5564599 C130.567485,34.1616098 133.348361,37.6000389 133.999964,41.736759 C132.526306,42.3662275 130.903031,42.7142857 129.19766,42.7142857 C126.503489,42.7142857 124.014212,41.8455957 121.999893,40.3756419 C124.521568,38.5363468 126.298564,35.7546566 126.801919,32.5550132 C125.329231,31.9267209 123.705956,31.5786627 122.000586,31.5786627 C120.327273,31.5786627 118.732999,31.9137581 117.282468,32.5198959 L117.198282,32.5561895 C117.102386,31.9474532 117.052597,31.3233907 117.052597,30.6878129 C117.052597,26.7629725 118.951238,23.2772536 121.888637,21.0821449 L122.002047,21.0005444 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.000586,31.5786627 C123.705956,31.5786627 125.329231,31.9267209 126.801919,32.5550132 C125.896422,38.3109231 120.869268,42.7142857 114.803511,42.7142857 C113.097839,42.7142857 111.474291,42.3661044 110.001396,41.7376019 C110.907674,35.9820253 115.934829,31.5786627 122.000586,31.5786627 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTabbarTrade);
export default __webpack_public_path__ + "static/media/light_tabbar_trade.93d979802cabf843d83533be9307a8e8.svg";
export { ForwardRef as ReactComponent };